import { useEffect, useState } from "react";
import api from "@/lib/api";

export const SENDER_KEY = "preferred_sender";
const LEGACY_KEY = "remind_sender"; // pre-shared-key storage, read once as fallback

/** Last chosen mailbox, shared across every send dialog (reminders + invoices). */
export const getSavedSender = () => localStorage.getItem(SENDER_KEY) || localStorage.getItem(LEGACY_KEY) || "";

/**
 * Shared "From" mailbox picker. Lists the user's connected mailboxes
 * (Namecheap IMAP / Gmail), snaps to a valid choice once loaded, and
 * remembers the pick for next time across all send dialogs.
 */
export const SenderPicker = ({ value, onChange, testid = "sender-picker", emptyTestid }) => {
  const [accounts, setAccounts] = useState(null); // null = loading

  useEffect(() => {
    let live = true;
    api.get("/email/accounts")
      .then((r) => {
        if (!live) return;
        const list = Array.isArray(r.data) ? r.data : (r.data?.accounts || []);
        setAccounts(list);
        if (!value || !list.some((a) => a.email === value)) onChange(list[0]?.email || "");
      })
      .catch(() => { if (live) setAccounts([]); });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pick = (email) => {
    localStorage.setItem(SENDER_KEY, email); // shared default for all send dialogs
    onChange(email);
  };

  if (accounts === null) return <p className="text-xs text-gray-400">Loading mailboxes…</p>;
  if (accounts.length === 0) {
    return (
      <p className="rounded border border-amber-300 bg-amber-50 px-2 py-1.5 text-xs text-amber-700" data-testid={emptyTestid || `${testid}-empty`}>
        No mailbox connected — connect one in the Mail tab to send.
      </p>
    );
  }
  return (
    <select value={value} onChange={(e) => pick(e.target.value)} data-testid={testid} className="w-full rounded border border-gray-300 bg-white px-2 py-1.5 text-xs text-gray-800 outline-none focus:border-[#1a3fd1]">
      {accounts.map((a) => (
        <option key={a.email} value={a.email}>{a.email}</option>
      ))}
    </select>
  );
};
